import { FC } from "react";
import { CircularProgress } from "@mui/material";
import { WishlistItem } from "./WishListItem";
import { TransformedProductEntity } from "../../../types/transformed_product_entity";
import withAuth from "../../hoc/withAuth";
import { useGetWishlistQuery } from "../../../store";
import { ApiError, NoItemsFound } from "../../atoms";
import { FcDislike } from "react-icons/fc";
import { useTypedSelector } from "../../../hooks/useTypedSelector";
import { AuthLayout } from "../../layouts";

export const WishlistMain: FC = () => {
  const isLoggedin = useTypedSelector(state => state.auth.isLoggedin);
  const { data, error, isLoading } = useGetWishlistQuery(undefined, {
    skip: !isLoggedin,
  });

  if (isLoading)
    return (
      <div className="flex-1 flex items-center justify-center">
        <CircularProgress size="small" />
      </div>
    );

  if (error) {
    <ApiError error={error} />;
  }

  return (
    <AuthLayout title="Wishlist">
      {data && data.length > 0 ? (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {data.map((product: TransformedProductEntity) => (
            <WishlistItem key={product.id} product={product} />
          ))}
        </div>
      ) : (
        <div className="mt-12">
          <NoItemsFound
            title="Oops! Your wishlist is empty"
            message="looks like you haven't added anything to your wishlist yet."
            icon={<FcDislike />}
          />
        </div>
      )}
    </AuthLayout>
  );
};

export const Wishlist = withAuth<{}>(WishlistMain);
